import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading } from '@chakra-ui/react';
import { Breadcrumb } from '@whitbread-eos/atoms';
import { formatAssetsUrl, formatDataTestId, useScreenSize } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CollapseExpandText = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('@whitbread-eos/atoms'),
    CollapseExpandText = _yield$import.CollapseExpandText;
  return {
    default: CollapseExpandText
  };
}), {
  ssr: false
});
export default function HeroSection(_ref2) {
  var data = _ref2.data;
  var baseDataTestId = 'DLPHeroSection';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var title = data.title,
    description = data.description,
    picture = data.picture;
  var _useScreenSize = useScreenSize(),
    isLessThanLg = _useScreenSize.isLessThanLg;
  var breadcrumbList = data.breadcrumbs.map(breadcrumb => ({
    name: breadcrumb.title,
    url: breadcrumb.link,
    isCurrentPage: breadcrumb.link === ''
  }));
  return _jsxs(Flex, _objectSpread(_objectSpread({}, heroSectionStyle), {}, {
    children: [_jsxs(Flex, _objectSpread(_objectSpread({
      flexDirection: "column"
    }, textContainerStyle), {}, {
      w: {
        mobile: 'full',
        md: !picture ? '54rem' : '50%'
      },
      children: [_jsx(Box, _objectSpread(_objectSpread({}, breadcrumbStyles), {}, {
        display: {
          mobile: !(picture && description) ? 'block' : 'none',
          md: 'block'
        },
        children: _jsx(Breadcrumb, {
          items: breadcrumbList
        })
      })), _jsx(Heading, _objectSpread(_objectSpread({
        as: "h1",
        "data-testid": formatDataTestId(baseDataTestId, 'Title')
      }, titleStyle), {}, {
        children: title
      })), description && getHeroDescription(description.toString(), baseDataTestId, isLessThanLg, t)]
    })), picture && description && _jsxs(Box, _objectSpread(_objectSpread({}, pictureStyle), {}, {
      children: [_jsx(Flex, _objectSpread(_objectSpread({
        flexDirection: "column"
      }, _objectSpread({}, breadcrumbStyles)), {}, {
        display: {
          mobile: 'block',
          md: 'none'
        },
        children: _jsx(Breadcrumb, {
          items: breadcrumbList
        })
      })), _jsx(Image, {
        src: formatAssetsUrl(picture),
        alt: title,
        width: 700,
        height: 600,
        sizes: "(max-width: 374px) 342px, (min-width: 375px) and (max-width: 575px) 543px, (min-width: 576px) and (max-width: 767px) 700px, (min-width: 768px) 624px",
        objectFit: "contain",
        style: {
          borderRadius: 'var(--chakra-space-sm)'
        },
        "data-testid": formatDataTestId(baseDataTestId, 'Picture'),
        priority: true
      })]
    }))]
  }));
}
export function getHeroDescription(description, baseDataTestId, isLessThanLg, t) {
  if (isLessThanLg || description.toString().length > 200) {
    return _jsx(CollapseExpandText, {
      startingHeight: 185,
      noOfLines: 7,
      baseTestId: baseDataTestId,
      expandButtonText: t('hoteldetails.readmore'),
      collapseButtonText: t('hoteldetails.readless'),
      contentText: description,
      isFadeEffect: true,
      isHtml: true
    });
  }
  return description;
}
var heroSectionStyle = {
  justifyContent: 'space-between',
  flexDirection: {
    mobile: 'column',
    md: 'row'
  },
  align: 'flex-start'
};
var textContainerStyle = {
  pr: {
    mobile: '0',
    md: 'lg'
  },
  order: {
    mobile: 2,
    md: 1
  }
};
var breadcrumbStyles = {
  py: 'lg',
  display: {
    mobile: 'none',
    md: 'block'
  }
};
var titleStyle = {
  color: 'tertiary',
  fontSize: {
    mobile: '2.5rem',
    md: '3.5rem'
  },
  fontFamily: 'var(--chakra-fonts-header)',
  fontWeight: 'var(--chakra-fontWeights-black)',
  letterSpacing: {
    mobile: '0',
    md: '-1px'
  },
  lineHeight: {
    mobile: '2.75rem'
  },
  mb: {
    mobile: 0,
    lg: 'md'
  },
  mt: {
    mobile: 'md',
    lg: '5xl'
  }
};
var pictureStyle = {
  w: {
    mobile: 'full',
    md: '50%'
  },
  mt: {
    mobile: 'md',
    sm: 0
  },
  order: {
    mobile: 1,
    md: 2
  },
  overflow: 'hidden',
  alignSelf: 'baseline'
};